enum AuthorizationStatusEnum {
	TODOS = 'TODOS',
	PENDENTE = 'PENDENTE',
	LIBERADO = 'LIBERADO',
	INDEFERIDO = 'INDEFERIDO',
}

type TrilhaStatus = {
	dsTrilha: string;
	dtRegistro: string;
};

type Authorization = {
	cdProcedimento: string;
	nmProcedimento: string;
	cdPrestador: string;
	nmPrestador: string;
	cdAutorizacaoSenha: string;
	cdSenha: string;
	dsSituacao: AuthorizationStatusEnum | string;
	dtAutorizacao: string;
	dtSolicitacao: string;
	dtValidade: string;
	nuProtocolo: string;
	nuControle: string;
	nuRegistro: string;
	protocolo?: string;
	nuProtocoloSolicitacao?: string;
	trilhaStatus: TrilhaStatus[];
};

type Content = {
	items: Authorization[];
	total: number;
	page: number;
	size: number;
	pages: number;
};

type AuthorizationsParams = {
	size?: number;
	page?: number;
	situacoes?: string;
	signal?: AbortSignal;
};

type GetAuthorizationsModel = Content;

interface GetAuthorizations {
	get: (params?: AuthorizationsParams) => Promise<GetAuthorizationsModel>;
}

export {AuthorizationStatusEnum};

export type {
	GetAuthorizations,
	GetAuthorizationsModel,
	TrilhaStatus,
	Authorization,
	AuthorizationsParams,
};
